import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ChevronDown, Search, Building2, UserCheck } from "lucide-react";
import "../assets/css/dropdown1.css";
import "../assets/css/line-awesome.css";
import "../assets/css/line-awesome.min.css";
import {
  topSearch,
  selectItem,
  topSearchClick,
} from "../actionCreator/headerActionCreater";

const SearchData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const topSearchValue = useSelector(
    (state) => state?.HeaderReducer?.topSearchValue,
  );
  const selectedItem = useSelector(
    (state) => state?.HeaderReducer?.selectedItem,
  );
  const [dropDownToggle, setDropdownToggle] = useState(false);
  const [searchValue, setSearchValue] = useState(topSearchValue);
  const handleSetValue = (event) => {
    setSearchValue(event.target.value);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setValue(selectedItem, true);
  };
  const setValue = (val, btn = false) => {
    const cleanPath = location.pathname.replace(/\/$/, "");
    let searchType = val;

    if (searchType !== "Company" && searchType !== "Executive") {
      if (cleanPath === "/search-executive") {
        searchType = "Executive";
      } else {
        searchType = "Company";
      }
    }

    dispatch(selectItem(searchType));
    dispatch(topSearchClick(Math.random()));

    if (!btn) {
      setDropdownToggle(!dropDownToggle);
    }
    dispatch(topSearch(searchValue));

    if (searchType === "Company") {
      navigate("/search-company");
    } else {
      navigate("/search-executive");
    }
  };
  const toggleDropdown = () => {
    setDropdownToggle(!dropDownToggle);
  };

  useEffect(() => {
    setSearchValue(topSearchValue);
  }, [topSearchValue]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanPath = location.pathname.replace(/\/$/, "");
    if (cleanPath === "/search-executive") {
      dispatch(selectItem("Executive"));
    } else if (cleanPath === "/search-company") {
      dispatch(selectItem("Company"));
    } else {
      dispatch(selectItem("Company"));
      dispatch(topSearch(""));
    }
  }, [location.pathname, dispatch]);

  return (
    <form
      onSubmit={handleSubmit}
      className="tw-flex tw-items-center tw-bg-white tw-border tw-border-solid tw-border-slate-200 tw-rounded-xl tw-px-3 tw-py-1 tw-shadow-sm focus-within:tw-border-[#5D44FF] focus-within:tw-ring-2 focus-within:tw-ring-indigo-100/50 tw-transition-all tw-h-9 tw-w-full tw-relative !tw-font-inter"
    >
      {/* Search Input */}
      <input
        type="search"
        placeholder="Search..."
        value={searchValue}
        onChange={handleSetValue}
        className="tw-flex-1 tw-bg-transparent tw-border-none tw-outline-none tw-text-xs tw-text-slate-700 tw-placeholder-slate-400 tw-py-1 tw-px-1 tw-min-w-0 !tw-font-inter"
      />

      {/* Dropdown Toggle */}
      <div
        onClick={toggleDropdown}
        className="tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer tw-px-2.5 tw-py-1 tw-border-l tw-border-r-0 tw-border-t-0 tw-border-b-0 tw-border-solid tw-border-slate-200 tw-text-slate-500 hover:tw-text-[#5D44FF] tw-transition-colors tw-h-5 tw-text-[11px] tw-font-semibold tw-whitespace-nowrap"
      >
        <span>{selectedItem}</span>
        <ChevronDown className="tw-w-3 tw-h-3" />
      </div>

      {/* Search Button */}
      <button
        type="submit"
        className="tw-flex tw-items-center tw-justify-center tw-text-slate-400 hover:tw-text-[#5D44FF] tw-transition-colors tw-bg-transparent tw-border-none tw-outline-none tw-cursor-pointer tw-p-1 tw-ml-1"
      >
        <Search className="tw-w-3.5 tw-h-3.5" />
      </button>

      {/* Dropdown List */}
      {dropDownToggle && (
        <ul className="tw-absolute tw-top-full tw-right-0 tw-mt-1.5 tw-w-36 tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-xl tw-shadow-lg tw-py-1 tw-list-none tw-z-50 tw-overflow-hidden">
          <li
            onClick={() => setValue("Company")}
            className="tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50 hover:tw-text-[#5D44FF] tw-cursor-pointer tw-flex tw-items-center tw-gap-2 tw-transition-colors"
          >
            <Building2 className="tw-w-3.5 tw-h-3.5" />
            Company
          </li>
          <li
            onClick={() => setValue("Executive")}
            className="tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50 hover:tw-text-[#5D44FF] tw-cursor-pointer tw-flex tw-items-center tw-gap-2 tw-transition-colors"
          >
            <UserCheck className="tw-w-3.5 tw-h-3.5" />
            Executive
          </li>
        </ul>
      )}
    </form>
  );
};

export default SearchData;
